export default "__VITE_ASSET__06llmEOZ__"